import { useEffect, useState } from 'react';

// Ticking "now" for time-derived UI (now-line, today highlight). Without a
// timer those freeze in idle tabs: a 60s poll returning identical data
// doesn't re-render, so `new Date()` captured at render time goes stale.
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
